import { combineReducers } from "redux";
import userReducer from "./userReducer";
import conversationReducer from "./conversationReducer";
import agentViewReducer from "./agentViewReducer";
import suggestionReducer from "./suggestionsReducer";
import alertReducer from "./alertReducer";
import attachmentsReducer from "./attachmentsReducer";
import adminViewReducer from "./adminViewReducer";
import dealerLocationSuggestionReducer from "./dealerLocationSuggestionReducer";
import userSessionReducer from "./userSessionReducer";
import agentTabReducer from "./agentTabReducer";
import agentBgMsgCountReducer from "./AgentSocketReducer";

const rootReducer = combineReducers({
  user: userReducer,
  conversation: conversationReducer,
  agentView: agentViewReducer,
  suggestion: suggestionReducer,
  alert: alertReducer,
  attachments: attachmentsReducer,
  adminView: adminViewReducer,
  dealerLocationSuggestion: dealerLocationSuggestionReducer,
  userSession: userSessionReducer,
  agentTab: agentTabReducer,
  agentBgMsgCount: agentBgMsgCountReducer,
});
export default rootReducer;
